/* unplugin-vue-components disabled */import { render } from "./templateRadio.vue?vue&type=template&id=b46f6b66&scoped=true"
import script from "./templateRadio.vue?vue&type=script&lang=js"
export * from "./templateRadio.vue?vue&type=script&lang=js"

import "./templateRadio.vue?vue&type=style&index=0&id=b46f6b66&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46f6b66"]])

export default __exports__